import { TEXT_KEYS } from '../../../constants/textKeys';
import IMAGES_PATH from '../../../Images';
import { t } from '../../../translation/translation';
import { Button } from '../../common/Button';
import './style.css'

export const SectionStore = () => {
    return (
        <div className='section'>
            <div className='section-store-title'>
                <h2>{t(TEXT_KEYS.STORE_SECTION_TITLE)}</h2>
            </div>
            <div className='section-store-button'>
                <div>
                    <Button
                        label={t(TEXT_KEYS.APPLE_STORE)}
                        iconLeft={IMAGES_PATH.LOGO_APPLE}
                    />
                </div>
                <div>
                    <Button
                        label={t(TEXT_KEYS.PLAY_STORE)}
                        iconLeft={IMAGES_PATH.LOGO_ANDROID}
                    />
                </div>
            </div>
        </div>
    );
};